import { useEffect, useRef, useState } from "react";
import SimpleBar from "simplebar-react";
import { formatNumber } from "./formatValue";
import { IAnalyticsDataItem } from "../types";
import { useTranslation } from "react-i18next";
import { CSSProperties } from "styled-components";
import useLocale from "../../../hooks/useLocale";
import { translateCategorySlug } from "../../../functions/translateCategorySlug";

interface IAnalitycsItemList {
	data: IAnalyticsDataItem[] | null
	by: "time" | "cost"
	isCategories?: boolean
}

export default function AnalitycsItemList({ data, by, isCategories }: IAnalitycsItemList) {

	const scrollableNodeRef = useRef<HTMLDivElement>(null),
		[progress, setProgress] = useState<number>(0),
		{ t } = useTranslation(),
		[minWidthValue, setMinWidthValue] = useState(0),
		[minWidthPercentage, setMinWidthPercentage] = useState(0),
		locale = useLocale(),
		isMin = window.innerWidth < 1700;

	useEffect(() => {
		const container = scrollableNodeRef.current;

		if (container) {
			container.addEventListener("scroll", () => {
				const progress = (container.offsetHeight + container.scrollTop) / container.scrollHeight * 100;
				setProgress(progress);
			})

			if (container.scrollHeight === container.offsetHeight) setProgress(100);
		}
	}, [])

	function average(numbers: number[]) {
		return numbers.reduce((a, b) => (a + b)) / numbers.length;
	}

	useEffect(() => {
		if(data && data.length) {
			const firstValItem = data[0], lastValItem = data[data.length-1];
			const fisrstValue = `${formatNumber(firstValItem.value, by === "time" ? 1 : 2).toLocaleString()}${by === "time" ? ` ${t("analytics_page.pie.h")}` : ` ${t("analytics_page.pie.uah")}`}`.length,
			lastValue = `${formatNumber(lastValItem.value, by === "time" ? 1 : 2).toLocaleString()}${by === "time" ? ` ${t("analytics_page.pie.h")}` : ` ${t("analytics_page.pie.uah")}`}`.length,
			delta = isMin ? 7 : 8.5;

			setMinWidthValue(average([fisrstValue * delta, lastValue * delta]));
			setMinWidthPercentage(`${formatNumber(firstValItem.percentage, 2)}%`.length)
		} else {
			setMinWidthValue(0);
			setMinWidthPercentage(0);
		}
	}, [locale, data, by, isMin, t])

	return <SimpleBar className="analytics-item__list-wrapper" scrollableNodeProps={{ ref: scrollableNodeRef }} autoHide={false}>
		<div className={`analytics-item__list${progress >= 90 ? " is-end" : ""}`} style={
			{
				"--min": `${Math.min(minWidthValue, locale === "ua" && by === "time" ? isMin ? 55 : 65 : by === "time" ? isMin ? 70 : 80 : isMin ? 110 : 120)}px`,
				"--min-percentage": `${minWidthPercentage * (isMin ? 5 : 6.5)}px`,
			} as CSSProperties}>
			{data && data.map((entry, index) => (
				<div key={`legend-item-${index}`} className="analytics-item__list-item" style={{ "--color": entry.color } as React.CSSProperties}>
					<span>
						<span>{isCategories ? translateCategorySlug(t, entry.name) : entry.name}</span>
					</span>
					<div>
						<span>{formatNumber(entry.percentage, 2)}%</span>
						<span>-</span>
						<span>{formatNumber(entry.value, by === "time" ? 1 : 2).toLocaleString()}{by === "time" ? ` ${t("analytics_page.pie.h")}` : ` ${t("analytics_page.pie.uah")}`}</span>
					</div>
				</div>
			))}
		</div>
	</SimpleBar>
}